<!--工作室详情-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="studio-container">
                <div class="left-menu-container">
                    <div class="menu-container">
                        <div @click="jumpStudio('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">概览</div>
                        <div @click="jumpStudio('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">工作室查询</div>
                        <div @click="jumpStudio('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">工作室成果</div>
                        <div @click="jumpStudio('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">工作室资讯</div>
                    </div>
                </div>
                <div class="right-content-container">
                    <!-- 工作室详情-->
                    <div class="nav_container">
                        <div class="nav-box">
                            <ul>
                                <li><a @click="changeActiveNum(0)" :class="activeNum===0?'is_active':''">首页</a></li>
                                <li><a @click="changeActiveNum(1)" :class="activeNum===1?'is_active':''">简介</a></li>
<!--                                <li><a @click="changeActiveNum(2)" :class="activeNum===2?'is_active':''">公告资讯</a></li>-->
                                <li><a @click="changeActiveNum(3)" :class="activeNum===3?'is_active':''">成果展示</a></li>
                                <li><a @click="changeActiveNum(4)" :class="activeNum===4?'is_active':''">教师文章</a></li>
                                <li><a @click="changeActiveNum(5)" :class="activeNum===5?'is_active':''">高水平示范课</a></li>
                                <li><a @click="changeActiveNum(7)" :class="activeNum===7?'is_active':''">区本课程</a></li>
                                <li><a @click="changeActiveNum(8)" :class="activeNum===8?'is_active':''">校本课程</a></li>
                                <li><a @click="changeActiveNum(6)" :class="activeNum===6?'is_active':''">工作日志</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="info-container">
                        <!-- 首页 -->
                        <detail-home v-show="activeNum===0"
                                     :studio-id="studioId"
                                     @change-nav-active="changeActiveNum"
                                     @view-studio-info-active="viewStudioInfo"/>
                        <!-- 简介 -->
                        <brief-introduction  v-show="activeNum===1"
                                             :studio-id="studioId"/>
                        <!-- 公告资讯 -->
                        <notice-news v-show="activeNum===2"
                                     :studio-id="studioId" />
                        <!-- 成果展示 -->
                        <studio-achievement v-show="activeNum===3"
                                            :studio-id="studioId"
                                            :achieve-mode="this.achieveMode"
                                            :parent-id="this.achieveId"
                                            @change-mode="changeMode"/>
                        <!-- 教师文章 -->
                        <studio-article v-show="activeNum===4"
                                        :studio-id="studioId"
                                        :achieve-mode="this.articleMode"
                                        :parent-id="this.articleId"
                                        @change-mode="changeMode"/>
                        <!-- 高水平示范课 -->
                        <studio-course v-show="activeNum===5"
                                       title="高水平示范课"
                                       courseType="1"
                                       :studio-id="studioId"
                                       :course-mode="this.courseMode"
                                       :parent-id="this.courseId"
                                       @change-mode="changeMode"/>
                        <!-- 区本课程 -->
                        <studio-course-qb v-show="activeNum===7"
                                       title="区本课程"
                                       courseType="2"
                                       :studio-id="studioId"
                                       :course-mode="this.qbCourseMode"
                                       :parent-id="this.qbCourseId"
                                       @change-mode="changeMode"/>
                        <!-- 校本课程 -->
                        <studio-course-xb v-show="activeNum===8"
                                       title="校本课程"
                                       courseType="3"
                                       :studio-id="studioId"
                                       :course-mode="this.xbCourseMode"
                                       :parent-id="this.xbCourseId"
                                       @change-mode="changeMode"/>
                        <!-- 工作日志 -->
                        <studio-log v-show="activeNum===6"
                                    :studio-id="studioId"
                                    :achieve-mode="this.logMode"
                                    :parent-id="this.logId"
                                    @change-mode="changeMode"/>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import homeFooter from "@/components/homeFooter";
import dataEmpty from "@/components/dataEmpty.vue";
import detailHome from "@/components/studioDetail/detailHome";
import briefIntroduction from "@/components/studioDetail/briefIntroduction.vue";
import noticeNews from "@/components/studioDetail/noticeNews.vue";
import studioAchievement from "@/components/studioDetail/studioAchievement";
import studioArticle from "@/components/studioDetail/studioArticle.vue";
import studioLog from "@/components/studioDetail/studioLog.vue";
import studioCourse from "@/components/studioDetail/studioCourse.vue";
import studioCourseQb from "@/components/studioDetail/studioCourseQb";
import studioCourseXb from "@/components/studioDetail/studioCourseXb";
export default {
    components: {
        dataEmpty,
        homeHead,
        homeFooter,
        detailHome,
        briefIntroduction,
        noticeNews,
        studioAchievement,
        studioArticle,
        studioLog,
        studioCourse,
        studioCourseQb,
        studioCourseXb
    },
    name: "homeStudioDetail",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activeNum: 0,
            activePath: "",
            activeItem:"1",
            studioId :'',
            studioNature:'',
            isStudioPeopleList: false,
            studioPeopleList: [],
            studioTitle: '',
            studioClassifyList: [],
            achieveId:'',
            achieveMode:'page',
            articleId:'',
            articleMode:'page',
            logId:'',
            logMode:'page',
            courseId:'',
            courseMode:'page',
            qbCourseId:'',
            qbCourseMode:'page',
            xbCourseId:'',
            xbCourseMode:'page',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.activePath = this.$store.state.params.jumpParams.activePath;
        this.activeItem = this.$store.state.params.jumpParams.activeItem;
        this.studioId = this.$store.state.params.jumpParams.studioId;
        this.studioNature = this.$store.state.params.jumpParams.studioNature;
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        jumpStudio(item){
            let jumpPath = '/hyedu/teastudio';
            if (this.studioNature==='3'){
                jumpPath = '/hyedu/rectorstudio';
            }
            //参数传递
            this.$store.commit("params/setJumpParams", {activePath:this.activePath,activeItem: item});
            this.$router.push({path: jumpPath});
        },
        changeActiveNum(i) {
            this.activeNum = i;
            if (i===3){
                this.achieveMode = this.pageMode;
            }
            if (i===4){
                this.articleMode = this.pageMode;
            }
            if (i===5){
                this.courseMode = this.pageMode;
            }
            if (i===6){
                this.logMode = this.pageMode;
            }
            if (i===7){
                this.qbCourseMode = this.pageMode;
            }
            if (i===8){
                this.xbCourseMode = this.pageMode;
            }

        },
        viewStudioInfo(infoId,i){
            this.activeNum = i;
            //成果
            if (i===3){
                this.achieveId = infoId;
                this.achieveMode = this.detailMode;
            }
            //文章
            if (i===4){
                this.articleId= infoId;
                this.articleMode = this.detailMode;
            }
            //高水平示范课
            if (i===5){
                this.courseId= infoId;
                this.courseMode = this.detailMode;
            }
            //区本课程
            if (i==7){
                this.qbCourseId= infoId;
                this.qbCourseMode = this.detailMode;
            }
            //校本课程
            if (i===8){
                this.xbCourseId= infoId;
                this.xbCourseMode = this.detailMode;
            }
            //日志
            if (i===6){
                this.logId= infoId;
                this.logMode = this.detailMode;
            }
        },
        changeMode(mode,i){
            if (i===3){
                this.achieveMode = mode;
            }
            if (i===4){
                this.articleMode = mode;
            }
            if (i===5){
                this.courseMode = mode;
            }
            if (i===6){
                this.logMode = mode;
            }
            if (i===7){
                this.qbCourseMode = mode;
            }
            if (i===8){
                this.xbCourseMode = mode;
            }
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.studio-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.menu-container{
    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    box-sizing: border-box;
    padding: 0 5px 0 10px;
}
.div-100{
    width: 100%!important;
    height: auto;
}
/deep/ .el-scrollbar .el-scrollbar__wrap {
    border-top: none !important;
}
/*导航栏*/
.nav_container {
    width: 100%;
    height: 40px;
    background: #ff7f2e;
    margin-top: -5px;
}
.nav-box{
    width: fit-content;
    height: 40px;
    margin: auto;
}
.nav-box ul{
    display: flex;
    width: fit-content;
    height: 40px!important;
    padding-inline-start: 0!important;
}
.nav-box ul li {
    position: relative;
    float: left;
    width: auto;
    text-align: center;
    line-height: 40px;
    list-style-type: none;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
}
.nav-box ul li a {
    color: #fff;
    display: block;
    cursor: pointer;
    font-size: 16px;
}
.nav-box ul li a:hover{
    color: #ffbf6b;
    font-weight: bold;
}
.is_active{
    font-weight: bold;
    color: #ffbf6b!important;
}
/*标题栏*/
.title-box100{
    display: flex;
    width: 100%;
    height: 100%;
    border-bottom: 2px solid #ff7f2e;
}
.title-name100{
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    //background-color: #cecece;
    cursor: pointer;
    text-indent: 10px;
}
.title-active100{
    color: #fff;
    background: #ff7f2e!important;
}
.title-box{
    display: flex;
    width: 100%;
    height: 34px;
    border-bottom: 2px solid #ff7f2e;
}
.title-name{
    width: auto;
    height: 34px;
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    //color: #fff;
    //background-color: #cecece;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    color: #ff7f2e;
}
.title-active{
    //color: #fff;
    //background: #ff7f2e!important;
}
.title-more{
    color: #666!important;
    font-size: 16px;
    height: 34px;
    line-height: 34px;
    margin-left: auto;
    padding-right: 10px;
    cursor: pointer;
}
.title-more:hover{
    color: #ff7f2e!important;
}
/*主要内容*/
.info-container{
    width: 100%;
    height: auto;
    margin-top: 10px;

}
</style>